var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTronIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF060A;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.6,881.2c243.4,0,440.6-197.3,440.6-440.6S684,0,440.6,0S0,197.3,0,440.6S197.3,881.2,440.6,881.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M688.4,364.8c-24.3-21.6-58.1-54.5-85.4-77.8l-1.7-1c-2.7-2-5.7-3.7-8.9-4.9l0,0c-66.2-11.8-374.1-67-380-66.3 c-1.7,0.2-3.4,0.8-4.7,1.7l-1.5,1.2c-1.9,1.9-3.4,4.1-4.2,6.6l-0.3,1v5.6v0.8c34.6,92.5,171.5,395.4,198.5,466.6 c1.7,4.9,4.7,14,10.5,14.5h1.4c3,0,16.2-16.7,16.2-16.7s235.2-273.1,259-302.2c3-3.5,5.7-7.4,8.1-11.5c0.7-3.2,0.3-6.4-0.8-9.5 C693.2,369.9,691,367,688.4,364.8L688.4,364.8z M488.2,396.7L588.5,317l58.9,52L488.2,396.7z M449.2,391.5L276.5,255.8l279.6,49.5 L449.2,391.5z M464.7,426.9l176.7-27.3L439.4,633.1L464.7,426.9z M253.1,269.4l181.8,147.7l-26.3,216.1L253.1,269.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTronIcon);
export default __webpack_public_path__ + "static/media/tron_icon.3b82eade979f4b227af034a39477f00c.svg";
export { ForwardRef as ReactComponent };